import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';

/* istanbul ignore next */
export default universal(
    universalImport({
        chunkName: () => 'CartPage',
        path: () => path.join(__dirname, './CartPage'),
        resolve: () => require.resolveWeak('./CartPage'),
        load: () =>
            Promise.all([import(/* webpackChunkName: "CartPage" */ './CartPage')]).then(
                (proms) => proms[0]
            ),
    })
);
